import CopyLink from '@/images/CopyLink.svg';
import { createShareRecord } from '@/services/api';
import { copyToClipboardAsShareUrl, sendShareMixpanelEvent } from '@/utils/shareUtils';
import { LibraryItem, LibraryItemStatus } from '@d-id/types';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, ListItemText } from './components';

interface Props {
    video: LibraryItem;
    closeMenu: () => void;
    origin: string;
}

export const CopyLinkMenuItem = ({ video, closeMenu, origin }: Props) => {
    if (video.status !== LibraryItemStatus.Done) {
        return null;
    }

    return (
        <MenuItem
            onClick={() => {
                createShareRecord(video!);
                copyToClipboardAsShareUrl({ itemId: video!.id });
                sendShareMixpanelEvent({
                    item: video,
                    modal: 'play',
                    to: 'copy',
                    from: origin,
                });
                closeMenu();
            }}>
            <ListItemIcon>
                <img src={CopyLink} />
            </ListItemIcon>
            <ListItemText>Copy link</ListItemText>
        </MenuItem>
    );
};
